// import React, { useState, useRef, useEffect } from "react";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import CloseIcon from "@mui/icons-material/Close";
// import { useNavigate } from "react-router-dom";
// import { FLEETRIFYROUTEPATH } from "../../../routes/routesPath";
// import { useGetAllServicesQuery } from "../../../redux/services/companyApi";
// import { FleetrifyBgs } from "../../../assets/video";
// import CarouselCard from "../../../components/Carousel";
// import { useProfileController as useIndividualProfile } from "../../../controllers/useIndividualProfile";

// interface Option {
//   id: string;
//   label: string;
// }

// interface CustomDropdownProps {
//   options: Option[];
//   value: string;
//   onChange: (value: string) => void;
//   placeholder?: string;
// }

// const CustomDropdown: React.FC<CustomDropdownProps> = ({ options, value, onChange, placeholder }) => {
//   const [open, setOpen] = useState(false);
//   const dropdownRef = useRef<HTMLDivElement>(null);

//   useEffect(() => {
//     const handleClickOutside = (event: MouseEvent) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
//         setOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   return (
//     <div ref={dropdownRef} className="relative w-full">
//       <button
//         type="button"
//         className="w-full bg-white border border-gray-300 text-[#4F4F4F] rounded-md px-5 py-2 text-left flex justify-between items-center cursor-pointer"
//         onClick={() => setOpen(!open)}
//       >
//         {options.find((o) => o.id === value)?.label || placeholder || "Select"}
//         <ExpandMoreIcon className={`transition-transform ${open ? "rotate-180" : ""}`} />
//       </button>

//       {open && (
//         <div
//           className="absolute bottom-full mb-1 w-full bg-white border border-gray-300 rounded-md shadow-lg overflow-auto z-50"
//           style={{ maxHeight: "200px" }}
//         >
//           {options.map((opt, idx) => (
//             <div
//               key={opt.id}
//               className={`px-4 py-2 cursor-pointer hover:bg-blue-100 ${idx < options.length - 1 ? "border-b border-gray-200" : ""}`}
//               onClick={() => {
//                 onChange(opt.id);
//                 setOpen(false);
//               }}
//             >
//               {opt.label}
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// const IndividualProfileSetUp: React.FC = () => {
//   const navigate = useNavigate();
//   const {
//     selectedServices,
//     toggleService,
//     removeService,
//     businessZone,
//     handleBusinessZoneChange,
//     hasOtherBranch,
//     setHasOtherBranch,
//     operationHours,
//     setOperationHours,
//     saveStep2,
//     submitProfile,
//     isSubmitting,
//   } = useIndividualProfile();

//   const [search, setSearch] = useState("");
//   const [isExpanded, setIsExpanded] = useState(true);

//   const { data: services = [], isLoading, isError } = useGetAllServicesQuery();

//   const days = ["Mondays", "Tuesdays", "Wednesdays", "Thursdays", "Fridays", "Saturdays", "Sundays"];
//   const hours = Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, "0") + ":00");
//   const periods = ["AM", "PM"];

//   const [fromDay, setFromDay] = useState("Mondays");
//   const [toDay, setToDay] = useState("Fridays");
//   const [fromHour, setFromHour] = useState("09:00");
//   const [fromPeriod, setFromPeriod] = useState("AM");
//   const [toHour, setToHour] = useState("05:00");
//   const [toPeriod, setToPeriod] = useState("PM");
  
//   const [errors, setErrors] = useState({
//     services: "",
//     operationHours: "",
//   });

//   const filteredServices = services.filter((s) => s.name.toLowerCase().includes(search.toLowerCase()));

//   const handleNext = () => {
//     const newErrors = { services: "", operationHours: "" };
//     let isValid = true;

//     // Validate services selection
//     if (selectedServices.length === 0) {
//       newErrors.services = "Please select at least one service";
//       isValid = false;
//     }
    
//     // Validate operation hours
//     if (!fromDay || !fromHour || !fromPeriod || !toDay || !toHour || !toPeriod) {
//       newErrors.operationHours = "Please fill in all Operation Hours fields";
//       isValid = false;
//     }

//     setErrors(newErrors);

//     if (!isValid) {
//       return;
//     }

//     const opHours = [
//       {
//         fromDay,
//         fromHour,
//         fromPeriod,
//         toDay,
//         toHour,
//         toPeriod,
//       },
//     ];

//     setOperationHours(opHours);
//     saveStep2(opHours);

//     navigate(FLEETRIFYROUTEPATH.ONBOARDINGINDIVIDUALKYCFORM);
//   };

//   const renderOperationHours = () => (
//     <div className="flex flex-col gap-4">
//       <div className="flex items-center gap-2">
//         <span className="text-[#143887]">From</span>
//         <CustomDropdown options={days.map((d) => ({ id: d, label: d }))} value={fromDay} onChange={setFromDay} />
//         <div className="flex items-center gap-1">
//           <CustomDropdown options={hours.map((h) => ({ id: h, label: h }))} value={fromHour} onChange={setFromHour} />
//           <CustomDropdown options={periods.map((p) => ({ id: p, label: p }))} value={fromPeriod} onChange={setFromPeriod} />
//         </div>
//       </div>

//       <div className="flex items-center gap-2">
//         <span className="text-[#143887]">To</span>
//         <CustomDropdown options={days.map((d) => ({ id: d, label: d }))} value={toDay} onChange={setToDay} />
//         <div className="flex items-center gap-1">
//           <CustomDropdown options={hours.map((h) => ({ id: h, label: h }))} value={toHour} onChange={setToHour} />
//           <CustomDropdown options={periods.map((p) => ({ id: p, label: p }))} value={toPeriod} onChange={setToPeriod} />
//         </div>
//       </div>
//       {errors.operationHours && (
//         <p className="text-red-500 text-sm">{errors.operationHours}</p>
//       )}
//     </div>
//   );

//   const renderServicesSelection = () => (
//     <div className="mt-6">
//       <label className="block font-bold text-[16px] mb-2">Select Services*</label>
//       <div className="border rounded-md overflow-hidden">
//         <div
//           className="flex items-center p-3 cursor-pointer gap-2 bg-[#F5F5F5] rounded-[4px]"
//           onClick={() => setIsExpanded(!isExpanded)}
//         >
//           <input
//             type="text"
//             placeholder="Search here"
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             onClick={(e) => e.stopPropagation()}
//             className="outline-none w-full bg-transparent text-sm"
//           />
//           <ExpandMoreIcon className={`text-gray-500 ${isExpanded ? "rotate-180" : ""}`} />
//         </div>

//         {isExpanded && (
//           <div className="flex flex-col md:flex-row gap-4 p-4 transition-all">
//             <div className="w-full md:w-1/2 space-y-2 pr-2 max-h-[200px] overflow-y-auto">
//               {isLoading && <p>loading...</p>}
//               {isError && <p className="text-red-500">failed to load services</p>}
//               {filteredServices.map((s) => (
//                 <div
//                   key={s.id}
//                   className="flex items-center justify-between px-3 py-2 bg-gray-100 hover:bg-gray-200 cursor-pointer rounded-md"
//                   onClick={() => toggleService(s.id)}
//                 >
//                   <span>{s.name}</span>
//                   <button className="text-blue-500 text-lg font-bold">
//                     {selectedServices.includes(s.id) ? "−" : "+"}
//                   </button>
//                 </div>
//               ))}
//             </div>

//             <div className="w-full md:w-1/2 space-y-2 max-h-[200px] overflow-y-auto">
//               {selectedServices.map((id) => {
//                 const service = services.find((s) => s.id === id);
//                 return (
//                   <div key={id} className="flex items-center justify-between rounded-md">
//                     <span className="text-sm">{service?.name || "unknown"}</span>
//                     <button onClick={() => removeService(id)}>
//                       <CloseIcon className="text-gray-700 text-[10px]" />
//                     </button>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         )}
//       </div>
//       {errors.services && (
//         <p className="text-red-500 text-sm mt-2">{errors.services}</p>
//       )}
//     </div>
//   );

//   const slides = [
//     { title: "Welcome to Fleetrify", description: "Login to manage logistics and fleet operations" },
//     { title: "Real-time Fleet Insights", description: "Get live updates and analytics on every vehicle in your fleet" },
//     { title: "Simplify Logistics Management", description: "Automate routing, tracking, and reporting — all in one platform" },
//   ];

//   return (
//     <div className="flex flex-col lg:flex-row">
//       {/* video section */}
//       <div className="relative w-full lg:w-[45%] lg:sticky top-0 flex-shrink-0" style={{ height: "calc(var(--vh, 1vh) * 100)" }}>
//         <video className="absolute inset-0 w-full h-full object-cover" autoPlay muted loop playsInline>
//           <source src={FleetrifyBgs} type="video/mp4" />
//         </video>
//         <div className="absolute inset-0 bg-black opacity-50 z-10"></div>
//         <div className="absolute inset-0 z-20 flex items-center justify-center">
//           <CarouselCard slides={slides} />
//         </div>

//         {/* mobile form */}
//         <div className="absolute inset-0 flex items-center justify-center z-30 px-4 md:px-8 lg:hidden">
//           <div className="w-full max-w-xl bg-white rounded-lg p-4 md:p-6 shadow-lg" style={{ maxHeight: "calc(var(--vh, 1vh) * 90)", overflow: "auto" }}>
//             <h2 className="text-[24px] md:text-2xl font-bold text-center text-[#143887]">INDIVIDUAL'S PROFILE</h2>
//             <p className="text-[16px] font-bold text-center text-[#4F4F4F] mt-1">Set up your profile</p>
//             {renderServicesSelection()}
//             <div className="mt-6">
//               <label className="text-[16px] font-bold mb-2">Business Location*</label>
//               <input type="text" value={businessZone} onChange={(e) => handleBusinessZoneChange(e.target.value)} className="w-full border border-gray-300 rounded-md px-4 py-2 outline-none" />
//             </div>
//             {/* <div className="mt-6 flex items-center justify-between">
//               <label className="text-sm font-medium">Do you have other Branches?*</label>
//               <input
//                 type="checkbox"
//                 checked={hasOtherBranch}
//                 onChange={(e) => setHasOtherBranch(e.target.checked)}
//                 className="w-5 h-5"
//               />
//             </div> */}
//             <div className="mt-6">
//               <label className="text-[16px] font-bold mb-2">Operation Hours*</label>
//               {renderOperationHours()}
//             </div>
//             <div className="mt-8 text-center">
//               <button onClick={handleNext} className="bg-[#0B1A51] text-white px-8 py-2 rounded-md hover:bg-[#132265] transition">Next</button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* desktop form */}
//       <div className="hidden lg:flex lg:w-[55%] lg:p-10 lg:items-center lg:justify-center bg-white">
//         <div className="max-w-[550px] w-full p-4 md:p-8">
//           <h2 className="text-[24px] md:text-2xl font-bold text-center text-[#143887]">INDIVIDUAL'S PROFILE</h2>
//           <p className="text-[16px] font-bold text-center text-[#4F4F4F] mt-1">Set up your profile</p>
//           {renderServicesSelection()}
//           <div className="mt-6">
//             <label className="text-[16px] font-bold mb-2">Business Location*</label>
//             <input type="text" value={businessZone} onChange={(e) => handleBusinessZoneChange(e.target.value)} className="w-full border border-gray-300 rounded-md px-4 py-2 outline-none" />
//           </div>
//           {/* <div className="mt-6 flex items-center justify-between">
//             <label className="text-sm font-medium">Do you have other Branches?*</label>
//             <input
//               type="checkbox"
//               checked={hasOtherBranch}
//               onChange={(e) => setHasOtherBranch(e.target.checked)}
//               className="w-5 h-5"
//             />
//           </div> */}
//           <div className="mt-6">
//             <label className="text-[16px] font-bold mb-2">Operation Hours*</label>
//             {renderOperationHours()}
//           </div>
//           <div className="mt-8 flex justify-center">
//             <button onClick={handleNext} className="bg-[#0B1A51] text-white px-8 py-2 w-[300px] max-w-full rounded-md hover:bg-[#132265] transition">Next</button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default IndividualProfileSetUp;





import React, { useState, useRef, useEffect } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";
import { FLEETRIFYROUTEPATH } from "../../../routes/routesPath";
import { FleetrifyBgs } from "../../../assets/video";
import CarouselCard from "../../../components/Carousel";
import { useProfileController as useIndividualProfile } from "../../../controllers/useIndividualProfile";

interface Option {
  id: string;
  label: string;
}

interface CustomDropdownProps {
  options: Option[];
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const CustomDropdown: React.FC<CustomDropdownProps> = ({
  options,
  value,
  onChange,
  placeholder,
}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} className="relative w-full">
      <button
        type="button"
        className="w-full bg-white border border-gray-300 text-[#4F4F4F] rounded-md px-4 py-3 text-left flex justify-between items-center cursor-pointer min-h-[48px]"
        onClick={() => setOpen(!open)}
      >
        <span className="truncate">
          {options.find((o) => o.id === value)?.label || placeholder || "Select"}
        </span>
        <ExpandMoreIcon
          className={`transition-transform flex-shrink-0 ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open && (
        <div
          className="absolute top-full mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg overflow-auto z-50"
          style={{ maxHeight: "220px" }}
        >
          {options.map((opt, idx) => (
            <div
              key={opt.id}
              className={`px-4 py-3 cursor-pointer hover:bg-blue-50 ${
                idx < options.length - 1 ? "border-b border-gray-200" : ""
              }`}
              onClick={() => {
                onChange(opt.id);
                setOpen(false);
              }}
            >
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const IndividualProfileSetUp: React.FC = () => {
  const navigate = useNavigate();
  const {
    businessZone,
    handleBusinessZoneChange,
    setOperationHours,
    saveStep2,
  } = useIndividualProfile();

  const days = [
    "Mondays",
    "Tuesdays",
    "Wednesdays",
    "Thursdays",
    "Fridays",
    "Saturdays",
    "Sundays",
  ];

  const hours = Array.from(
    { length: 12 },
    (_, i) => `${String(i + 1).padStart(2, "0")}:00`
  );

  const periods = ["AM", "PM"];

  const [fromDay, setFromDay] = useState("Mondays");
  const [toDay, setToDay] = useState("Fridays");
  const [fromHour, setFromHour] = useState("09:00");
  const [fromPeriod, setFromPeriod] = useState("AM");
  const [toHour, setToHour] = useState("05:00");
  const [toPeriod, setToPeriod] = useState("PM");

  const [errors, setErrors] = useState({
    operationHours: "",
    businessZone: "",
  });

  const handleNext = () => {
    const newErrors = {
      operationHours: "",
      businessZone: "",
    };

    let isValid = true;

    if (!businessZone.trim()) {
      newErrors.businessZone = "Business location is required";
      isValid = false;
    }

    if (!fromDay || !fromHour || !fromPeriod || !toDay || !toHour || !toPeriod) {
      newErrors.operationHours = "Please fill in all Operation Hours fields";
      isValid = false;
    }

    setErrors(newErrors);

    if (!isValid) return;

    const opHours = [
      {
        fromDay,
        fromHour,
        fromPeriod,
        toDay,
        toHour,
        toPeriod,
      },
    ];

    setOperationHours(opHours);
    saveStep2(opHours);

    navigate(FLEETRIFYROUTEPATH.ONBOARDINGINDIVIDUALKYCFORM);
  };

  const renderOperationHours = () => (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-1 md:grid-cols-[70px_1fr] gap-3 md:items-center">
        <span className="text-[#143887] font-medium">From</span>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <CustomDropdown
            options={days.map((d) => ({ id: d, label: d }))}
            value={fromDay}
            onChange={setFromDay}
            placeholder="Day"
          />
          <CustomDropdown
            options={hours.map((h) => ({ id: h, label: h }))}
            value={fromHour}
            onChange={setFromHour}
            placeholder="Hour"
          />
          <CustomDropdown
            options={periods.map((p) => ({ id: p, label: p }))}
            value={fromPeriod}
            onChange={setFromPeriod}
            placeholder="AM/PM"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-[70px_1fr] gap-3 md:items-center">
        <span className="text-[#143887] font-medium">To</span>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <CustomDropdown
            options={days.map((d) => ({ id: d, label: d }))}
            value={toDay}
            onChange={setToDay}
            placeholder="Day"
          />
          <CustomDropdown
            options={hours.map((h) => ({ id: h, label: h }))}
            value={toHour}
            onChange={setToHour}
            placeholder="Hour"
          />
          <CustomDropdown
            options={periods.map((p) => ({ id: p, label: p }))}
            value={toPeriod}
            onChange={setToPeriod}
            placeholder="AM/PM"
          />
        </div>
      </div>

      {errors.operationHours && (
        <p className="text-red-500 text-sm">{errors.operationHours}</p>
      )}
    </div>
  );

  const slides = [
    {
      title: "Welcome to Fleetrify",
      description: "Login to manage logistics and fleet operations",
    },
    {
      title: "Real-time Fleet Insights",
      description: "Get live updates and analytics on every vehicle in your fleet",
    },
    {
      title: "Simplify Logistics Management",
      description: "Automate routing, tracking, and reporting — all in one platform",
    },
  ];

  const renderForm = () => (
    <div className="w-full max-w-[560px] bg-white rounded-2xl p-5 md:p-8 shadow-lg lg:shadow-none">
      <h2 className="text-[24px] md:text-[28px] font-bold text-center text-[#143887]">
        INDIVIDUAL&apos;S PROFILE
      </h2>
      <p className="text-[15px] md:text-[16px] font-medium text-center text-[#4F4F4F] mt-2">
        Set up your profile
      </p>

      <div className="mt-8 space-y-6">
        <div>
          <label className="block text-[16px] font-semibold text-[#1F2937] mb-2">
            Business Location*
          </label>
          <input
            type="text"
            value={businessZone}
            onChange={(e) => handleBusinessZoneChange(e.target.value)}
            placeholder="Enter your business location"
            className="w-full border border-gray-300 rounded-md px-4 py-3 outline-none min-h-[48px] focus:border-[#143887]"
          />
          {errors.businessZone && (
            <p className="text-red-500 text-sm mt-2">{errors.businessZone}</p>
          )}
        </div>

        <div>
          <label className="block text-[16px] font-semibold text-[#1F2937] mb-3">
            Operation Hours*
          </label>
          {renderOperationHours()}
        </div>

        <div className="pt-2">
          <button
            onClick={handleNext}
            className="w-full bg-[#0B1A51] text-white px-8 py-3 rounded-md hover:bg-[#132265] transition font-medium min-h-[50px]"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="flex flex-col lg:flex-row min-h-screen bg-white">
      <div
        className="relative w-full lg:w-[45%] lg:sticky lg:top-0 flex-shrink-0"
        style={{ height: "calc(var(--vh, 1vh) * 100)" }}
      >
        <video
          className="absolute inset-0 w-full h-full object-cover"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src={FleetrifyBgs} type="video/mp4" />
        </video>

        <div className="absolute inset-0 bg-black/50 z-10" />

        <div className="absolute inset-0 z-20 hidden lg:flex items-center justify-center px-6">
          <CarouselCard slides={slides} />
        </div>

        <div className="absolute inset-0 flex items-center justify-center z-30 px-4 md:px-8 lg:hidden">
          <div
            className="w-full"
            style={{
              maxHeight: "calc(var(--vh, 1vh) * 90)",
              overflow: "auto",
            }}
          >
            {renderForm()}
          </div>
        </div>
      </div>

      <div className="hidden lg:flex lg:w-[55%] lg:px-10 xl:px-16 lg:py-10 lg:items-center lg:justify-center bg-white">
        {renderForm()}
      </div>
    </div>
  );
};

export default IndividualProfileSetUp;